module.exports = __webpack_public_path__ + "static/media/logo.a46a7c13.svg";